// extracted by mini-css-extract-plugin
module.exports = {"ButtonVolume":"SoundButton_ButtonVolume__3dGqT","Mute":"SoundButton_Mute__1-7BM"};